<template>
  <div ref="canvasWrapper" class="relative">
    <canvas ref="canvas" class="absolute left-0 top-0 origin-top-left" />
  </div>
</template>

<script setup>
import { computed, inject, ref } from "vue"

import { useSetupPage } from "../../composables/common/setupPage"

const props = defineProps(["isShowExtractedWords", "isForceShowHighlightBlocks", "seeSourceAttributeSlug"])

const isShowExtractedWords = computed(() => props.isShowExtractedWords)
const isForceShowHighlightBlocks = computed(() => props.isForceShowHighlightBlocks)
const seeSourceAttributeSlug = computed(() => props.seeSourceAttributeSlug)

const canvasWrapper = ref(null)
const canvas = ref(null)

const keyboardState = inject("KEYBOARD_STATE")
const containerState = inject("CONTAINER_STATE")
const pagingState = inject("PAGING_STATE")
const currentPageState = inject("CURRENT_PAGE_STATE")
const scalingState = inject("SCALING_STATE")
const wordTooltipState = inject("WORD_TOOLTIP_STATE")

useSetupPage({
  isShowExtractedWords,
  isForceShowHighlightBlocks,
  seeSourceAttributeSlug,
  keyboardState,
  containerState,
  pagingState,
  currentPageState,
  scalingState,
  wordTooltipState,
  canvasWrapper,
  canvas
})
</script>
